var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
var defaultStrings = {
    allItemsAreSelected: 'All items are selected.',
    clearSearch: 'Clear Search',
    clearSelected: 'Clear Selected',
    noOptions: 'No options',
    search: 'Search',
    selectAll: 'Select All',
    selectSomeItems: 'Select...',
    create: 'Create',
};
var defaultProps = {
    value: [],
    hasSelectAll: true,
    className: 'multi-select',
    debounceDuration: 200,
    options: [],
};
var MultiSelectContext = React.createContext({});
export var MultiSelectProvider = function (_a) {
    var props = _a.props, children = _a.children;
    var _b = useState(props.options), options = _b[0], setOptions = _b[1];
    var t = function (key) { var _a; return ((_a = props.overrideStrings) === null || _a === void 0 ? void 0 : _a[key]) || defaultStrings[key]; };
    // useEffect(() => {}, [options])
    return (React.createElement(MultiSelectContext.Provider, { value: __assign(__assign({ t: t }, defaultProps), props) }, children));
};
export var useMultiSelect = function () { return React.useContext(MultiSelectContext); };



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/hooks/UseMultiSelect.tsx
// module id = 104
// module chunks = 0